import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

import { PlatonSharedModule } from '../shared';

import {
    _screensState,
    CompanyComponent,
    CompanyCreateComponent,
    companyCreateState,
    CompanyDetailComponent,
    companyDetailState,
    companyState,
    ContactActivePipe,
    CompanyGroupComponent,
    CompanyGroupCreateComponent,
    companyGroupCreateState,
    CompanyGroupDetailComponent,
    companyGroupDetailState,
    companyGroupState,
    ContactComponent,
    ContactCreateComponent,
    contactCreateState,
    ContactDetailComponent,
    contactDetailState,
    ContactNamePipe,
    contactState,
    DocumentGenerationComponent,
    FormatDatePipe,
    LabelSkillComponent,
    TrainerCardComponent,
    LocationComponent,
    LocationCreateComponent,
    LocationDetailComponent,
    locationState,
    locationCreateState,
    locationDetailState,
    PanelCardsComponent,
    RegistrationBookingComponent,
    RegistrationCompanyComponent,
    RegistrationContactComponent,
    RegistrationStudentComponent,
    ProfileComponent,
    profileState,
    SessionCalendarComponent,
    SessionCalendarCardComponent,
    SessionCalendarDateComponent,
    SessionCalendarAgencyComponent,
    sessionCalendarState,
    SessionCompanyEditionComponent,
    SessionFinancingEditionComponent,
    SessionSalesPersonEditionComponent,
    SessionContactEditionComponent,
    SessionCreateComponent,
    sessionCreateState,
    SessionSurveyMonkey,
    SessionDetailComponent,
    SessionDetailDescriptionComponent,
    SessionDetailRegistrationComponent,
    SessionDetailEvaluationsComponent,
    SessionDetailTrainerEvaluationsComponent,
    sessionDetailState,
    SessionFormComponent,
    sessionFormState,
    SessionListComponent,
    sessionListState,
    mySessionListState,
    deletedSessionListState,
    SessionsHaveTraineesPipe,
    SessionStaffingArchivedPipe,
    SessionStaffingComponent,
    SessionStaffingCreateComponent,
    sessionStaffingCreateState,
    SessionStaffingDetailComponent,
    sessionStaffingDetailState,
    SessionStaffingSearchPipe,
    sessionStaffingState,
    sessionStaffingAnswersState,
    SessionStudentEditionComponent,
    SessionUpdateComponent,
    sessionUpdateState,
    StudentComponent,
    StudentDetailComponent,
    studentDetailState,
    studentState,
    TechnicalComponent,
    technicalState,
    TrainerComponent,
    TrainerCreateComponent,
    trainerCreateState,
    TrainerDetailComponent,
    TrainerDetailDescriptionComponent,
    TrainerDetailSkillComponent,
    TrainerDetailEvaluationComponent,
    trainerDetailState,
    TrainersAgencyNamePipe,
    TrainersAgencyPipe,
    TrainersLanguagePipe,
    TrainersLabelPipe,
    TrainersNamePipe,
    TrainersSkillsPipe,
    trainerState,
    TrainingComponent,
    TrainingDetailComponent,
    TrainingDetailDetailComponent,
    TrainingDetailDescriptionComponent,
    TrainingDetailPlanningComponent,
    TrainingDetailPlanningDetailComponent,
    trainingDetailPlanningDetailState,
    TrainingDetailEvaluationComponent,
    trainingDetailState,
    TrainingsActivePipe,
    trainingState,
    TrainingsTitlePipe,
    TrainingsLocationFilterPipe,
    TrainingsLocationRemoveDuplicatePipe,
    UniverseComponent,
    UniverseCreateComponent,
    UniverseDetailComponent,
    universeState,
    universeCreateState,
    universeDetailState,
    trainingCreateState,
    TrainingCreateComponent,
    PartnerComponent,
    PartnerCreateComponent,
    PartnerDetailComponent,
    partnerState,
    partnerCreateState,
    partnerDetailState,
    NavigateSessionIdComponent,
    LastProposalAnswersComponent,
    InitialsPipe,
} from './';

import {
    BillingProcessService,
    CompanyService,
    CompanyGroupService,
    ContactService,
    DownloadService,
    LocationService,
    SessionProposalService,
    SessionService,
    SessionViewCalendarService,
    SessionStaffingService,
    StatisticService,
    TechnicalsService,
    TrainerService,
    TrainingPlanningAgencyService,
    TrainingPlanningService,
    TrainingPriceService,
    TrainingService,
    TrainingSessionCompanyService,
    TrainingSessionCompanyHistoryService,
    EvaluationService,
    StudentService,
    RegistrationService,
    RegistrationDetailService,
    UniverseService,
    ProfileService,
    PartnerService,
    GraphQlService,
    CacheService,
} from '../_services';

import { CompaniesNamePipe } from './_shared/companies-name.pipe';
import { CommaDotPipe } from './_shared/comma-dot.pipe';
import { LocationsNamePipe } from './_shared/locations-name.pipe';
import { StudentsFirstnameLastnameCompanyNamePipe } from './_shared/students-firstname-lastname-companyname.pipe';
import { ChartsModule } from 'ng2-charts';
import {
    DataAnalysisComponent,
    dataAnalysisState,
    FloatingTurnoverComponent,
    turnoverState,
} from './stats';
import { TrainingDataAnalysisComponent } from './stats/data-analysis/training/training.component';
import { TrainingDataAnalysisValueComponent } from './stats/data-analysis/_component/data-analysis-value.component';
import { CompanyDataAnalysisComponent } from './stats/data-analysis/company/company.component';
import { TrainingDataAnalysisModalComponent } from './stats/data-analysis/_component/data-analysis-modal.component';
import { CompanyGroupsPipe } from './_shared/company-groups.pipe';
import { roomState } from './directory/location/room/room.state';
import { RoomComponent } from './directory/location/room/room.component';
import { RoomsNamePipe } from './_shared/rooms-name.pipe';
import { CustomDatepickerI18n, I18n } from './_shared/datepicker-i18n';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { UniversesNamePipe } from './_shared/universes-name.pipe';
import { PartnersNamePipe } from './_shared/partners-name.pipe';
import {
    StaffingSearchComponent,
    StaffingResultComponent,
    StaffingResultAnswerComponent,
} from './_shared/staffing';
import { ReactiveFormsModule } from '@angular/forms';

let _SCREENS_STATE = [
    sessionCalendarState,
    sessionDetailState,
    sessionListState,
    mySessionListState,
    deletedSessionListState,
    sessionStaffingState,
    sessionStaffingCreateState,
    sessionStaffingDetailState,
    sessionStaffingAnswersState,
    sessionFormState,
    sessionCreateState,
    sessionUpdateState,

    studentState,
    studentDetailState,
    turnoverState,
    dataAnalysisState,

    technicalState,

    profileState,

    contactState,
    contactDetailState,
    contactCreateState,

    trainerState,
    trainerCreateState,
    trainerDetailState,

    trainingState,
    trainingCreateState,
    trainingDetailState,
    trainingDetailPlanningDetailState,

    companyState,
    companyDetailState,
    companyCreateState,

    companyGroupCreateState,
    companyGroupDetailState,
    companyGroupState,

    locationState,
    locationCreateState,
    locationDetailState,

    roomState,

    universeState,
    universeCreateState,
    universeDetailState,

    partnerState,
    partnerCreateState,
    partnerDetailState,

    _screensState,
];

@NgModule({
    imports: [
        PlatonSharedModule,
        ChartsModule,
        UIRouterModule.forChild({ states: _SCREENS_STATE }),
        Ng2AutoCompleteModule,
        MultiselectDropdownModule,
        ReactiveFormsModule,
    ],
    declarations: [
        SessionCalendarComponent,
        SessionCalendarCardComponent,
        SessionCalendarDateComponent,
        SessionCalendarAgencyComponent,
        SessionDetailComponent,
        SessionSurveyMonkey,
        SessionDetailRegistrationComponent,
        SessionDetailDescriptionComponent,
        SessionListComponent,
        SessionStaffingComponent,
        SessionStaffingCreateComponent,
        SessionStaffingDetailComponent,
        SessionFinancingEditionComponent,
        SessionSalesPersonEditionComponent,
        SessionCompanyEditionComponent,
        SessionStaffingArchivedPipe,
        SessionStaffingSearchPipe,
        SessionFormComponent,
        SessionContactEditionComponent,
        SessionStudentEditionComponent,
        SessionCreateComponent,
        SessionUpdateComponent,
        SessionDetailEvaluationsComponent,
        SessionDetailTrainerEvaluationsComponent,

        FloatingTurnoverComponent,
        DataAnalysisComponent,
        TrainingDataAnalysisComponent,
        TrainingDataAnalysisModalComponent,
        TrainingDataAnalysisValueComponent,
        CompanyDataAnalysisComponent,

        TechnicalComponent,

        ContactComponent,
        ContactDetailComponent,
        ContactCreateComponent,

        TrainerComponent,
        TrainerCreateComponent,
        TrainerDetailComponent,
        TrainerDetailDescriptionComponent,
        TrainerDetailSkillComponent,
        TrainerDetailEvaluationComponent,

        TrainingComponent,
        TrainingDetailComponent,
        TrainingDetailDetailComponent,
        TrainingDetailDescriptionComponent,
        TrainingDetailPlanningComponent,
        TrainingDetailPlanningDetailComponent,
        TrainingDetailEvaluationComponent,
        TrainingCreateComponent,

        LabelSkillComponent,
        TrainerCardComponent,
        PanelCardsComponent,

        StudentComponent,
        StudentDetailComponent,
        StudentsFirstnameLastnameCompanyNamePipe,

        TrainersNamePipe,
        TrainersSkillsPipe,
        TrainersLabelPipe,
        TrainersAgencyPipe,
        TrainersAgencyNamePipe,
        TrainersLanguagePipe,

        TrainingsTitlePipe,
        TrainingsActivePipe,
        TrainingsLocationFilterPipe,
        TrainingsLocationRemoveDuplicatePipe,

        ContactActivePipe,
        ContactNamePipe,

        FormatDatePipe,
        SessionsHaveTraineesPipe,

        CompanyComponent,
        CompaniesNamePipe,
        CommaDotPipe,
        CompanyDetailComponent,
        CompanyCreateComponent,

        CompanyGroupComponent,
        CompanyGroupsPipe,
        CompanyGroupDetailComponent,
        CompanyGroupCreateComponent,

        LocationComponent,
        LocationCreateComponent,
        LocationDetailComponent,
        LocationsNamePipe,

        RoomComponent,
        RoomsNamePipe,

        ProfileComponent,

        RegistrationCompanyComponent,
        RegistrationContactComponent,
        RegistrationStudentComponent,
        RegistrationBookingComponent,

        UniverseComponent,
        UniverseCreateComponent,
        UniverseDetailComponent,
        UniversesNamePipe,

        PartnerComponent,
        PartnerCreateComponent,
        PartnerDetailComponent,
        PartnersNamePipe,

        DocumentGenerationComponent,
        NavigateSessionIdComponent,

        StaffingSearchComponent,
        StaffingResultComponent,
        StaffingResultAnswerComponent,

        LastProposalAnswersComponent,

        InitialsPipe,
    ],
    providers: [
        BillingProcessService,
        CompanyService,
        CompanyGroupService,
        ContactService,
        DownloadService,
        LocationService,
        SessionService,
        SessionViewCalendarService,
        SessionProposalService,
        SessionStaffingService,
        StatisticService,
        RegistrationDetailService,
        RegistrationService,
        TechnicalsService,
        TrainingPlanningAgencyService,
        TrainerService,
        TrainingService,
        TrainingPlanningService,
        TrainingPriceService,
        TrainingSessionCompanyService,
        TrainingSessionCompanyHistoryService,
        StudentService,
        UniverseService,
        PartnerService,
        EvaluationService,
        ProfileService,
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        GraphQlService,
        CacheService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlatonScreensModule {}



// WEBPACK FOOTER //
// ./src/app/_screens/_screens.module.ts